import { Card, CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import MaterialTypography from "../../../components/MaterialTypography"
import { useNavigate, useSearchParams } from "react-router-dom"
import MaterialBox from "../../../components/MaterialBox"
import MaterialSelect from "../../../components/MasterSelect"
import { useDistrictFormHandling } from "./components/DistrictStateHandle"
import MaterialInput from "../../../components/MaterialInput"
import MaterialButton from "../../../components/MaterialButton"
import { useEffect, useState } from "react"
import { fetchData, fetchDataById, postData, putData } from "../../../services"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"

const DistrictForm = () => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();
  const districtId = searchParams.get("id");
  const pageType = searchParams.get("pageType");
  const pageMode = pageType === "view" ? "view" : pageType === "edit" 
  ? "edit" : "add";
  const [countryDropdownOptions, setCountryDropdownOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  
  
  useEffect(() => {
    //Dropdown API
    if(pageMode!=="view"){
      const fetchCountryList = async () => {
        setCircleLoading(true);
        try {
          const response = await fetchData(`/reference/general/country?dropdown=true&isActive=true`)                
          if(response?.success){
            const formattedCountries = response?.data?.items?.map((item) => ({
              value: item.id,
              label: item.displayName,
            }));
            
            setCountryDropdownOptions(formattedCountries);                }
            else{
              //throw error
              showSnackbar("Error fetching Country","error")
            }
          } catch (error) {
            console.error('Error Fetching Countries:', error);
            showSnackbar("Error fetching Country","error")
          }finally{
            setCircleLoading(false);
          }
        };
        fetchCountryList();
      }
      
    },[pageMode])
    
    useEffect(() => {
      if((pageMode === "add") || (!districtId)){
        return
      }
      const fetchCountryById = async (districtId) => {
        try {
        const data = await fetchDataById(`/reference/general/district/${districtId}`);
        const responseData = data?.data;
        
        if(data?.success){
          setFormData(prev => ({
            ...prev,
            name: responseData.name || "",
            active: responseData.isActive,
            iplDistrictId: responseData.id || "",
            countryId: {value: responseData?.state?.country?.id, label: responseData?.state?.country?.name},
            stateId: {value: responseData?.state?.id, label: responseData?.state?.name},
            // reset status fields
            nameStatus: responseData.name ? "success" : "unchecked",
            iplDistrictIdStatus: responseData.id ? "success" : "unchecked",
            countryIdStatus: responseData?.state?.country?.id  ? "success" : "unchecked",
            stateIdStatus: responseData?.state?.name ? "success" : "unchecked"
          }));
        }
        else{
          //throw error message
          
        }
      } catch (error) {
        console.error('Error fetching data by ID:', error);
      }
    };
    fetchCountryById(districtId);
  },[pageMode])
  
  const fetchStateDropdown = async (countryId) => {
    try {
      const response = await fetchData(`/reference/general/state?dropdown=true&isActive=true&countryId=${countryId}`)
      
      if(response?.success){
        const formattedStates = response?.data?.items.map((item) => ({
          value: item.id,
          label: item?.name
        }))
        setStateOptions(formattedStates);
      }
      else{
        //throw error
      }
    }       
    catch (error) {
      console.error('Error Fetching States:', error);
    }
  };

  const handleSubmitDistrict = async () => {
    const payload = { 
        stateId: formData?.stateId?.value,
        name: formData?.name, 
        isActive: formData?.active
    };
    //Update
    if(districtId){
        try {
            const response = await putData(`/reference/general/district/${districtId}`, payload);
            const responseMessage = response?.message;
            if(response?.success){
            //success message
                showSnackbar(responseMessage, "success");
                navigate('/general-master/district-list');          
            }
            else{
                //error message
                showSnackbar(responseMessage, "error");
            }
        } catch (error) {
            console.error('Error updating data:', error);
            showSnackbar("Error Updating District", "error")
        }
    }
    else{      
    //Submit
    try {
        const response = await postData('/reference/general/district', payload);
        const responseMessage = response?.message;
        if(response?.success){
            //success message
            showSnackbar(responseMessage,"success");
            navigate('/general-master/district-list');          
        }
        else{
            //error message
            showSnackbar(responseMessage,"error");
        }
    } catch (error) {
        //catch error message
        console.error('Error posting data:', error);
        showSnackbar("Error Submitting District","error");
    }
    }
  };
  
  const { formData, setFormData, handleChange, checkAllFields } = useDistrictFormHandling({fetchStateDropdown});
  
  return (
    <DashboardLayout>
      <Card sx={{ minHeight: 500 }}>
        <CardHeader
            title={(
                <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <IconButton onClick={() => navigate("/general-master/district-list")}>
                        <ArrowBack />
                        </IconButton>
                        <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            District Details
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            Enter New District Details from around the world.
                        </MaterialTypography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
        />

        <CardContent>
          <Grid2 container spacing={2}>
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
              <MaterialBox>
                 <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold">
                      Country Name*
                  </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
              name="countryId"
              value={formData.countryId}
              onChange={handleChange}
              options={countryDropdownOptions}
              success={formData.countryIdStatus === "success"}
              error={formData.countryIdStatus === "error"}
              isDisabled={pageMode === "view"}
              />
            </Grid2>
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
              <MaterialBox>
                 <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold">
                      State Name*
                  </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
              name="stateId"
              options={stateOptions}
              value={formData.stateId}
              onChange={handleChange}
              success={formData.stateIdStatus === "success"}
              error={formData.stateIdStatus === "error"}
              isDisabled={formData.countryId === "" || pageMode === "view"}
              />
            </Grid2> 
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
              <MaterialBox>
                <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold">
                  District Name*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
              name="name"
              placeholder="eg. Chennai"
              value={formData.name}
              onChange={handleChange}
              success={formData.nameStatus === "success"}
              error={formData.nameStatus === "error"}
              disabled={pageMode === "view"}
              />
              {formData.nameStatus === "error" && (
                <FormControl error>
                    <FormHelperText>
                    District Name should be a minimum 1 character & maximum 170 characters long.
                    </FormHelperText>
                </FormControl>
              )
              }
            </Grid2> 
            {(pageMode === "edit" || pageMode === "view") && (
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                <MaterialBox>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold">
                      District ID
                    </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                name="iplDistrictId"
                value={formData.iplDistrictId}
                onChange={handleChange}
                success={formData.iplDistrictIdStatus === "success"}
                error={formData.iplDistrictIdStatus === "error"}
                disabled
                />
            </Grid2>
            )}
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                <MaterialBox>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold">
                        Actve
                    </MaterialTypography>
                </MaterialBox>
                <FormControlLabel
                control={
                    <Switch
                        checked={formData.active}
                        disabled={pageMode === "view"}
                        onChange={(e) =>
                            handleChange({
                                target: {
                                    name: "active",
                                    value: e.target.checked,
                                },
                            })
                        }
                        color="primary"
                    />
                }
                label={
                    <MaterialTypography variant="caption" fontWeight="bold">
                        {formData?.active ? "Yes" : "No"}
                    </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
                />
            </Grid2>
          </Grid2>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
      {pageMode === "add" && (
      <>
          <MaterialButton
          sx={{ m: 2 }}
          variant="outlined"
          color="dark"
          onClick={() => navigate("/general-master/district-list")}
          >
          Cancel
          </MaterialButton>
          <MaterialButton
          sx={{ m: 2 }}
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleSubmitDistrict}
          >
          Submit
          </MaterialButton>
      </>
      )}

      {pageMode==="edit" && (
      <>
        <MaterialButton
        variant="outlined"
        color="dark"
        sx={{ m: 2 }}
        onClick={() => navigate("/general-master/district-list")}
        >
        Cancel
        </MaterialButton>
        <MaterialButton
        sx={{ m: 2 }}
        variant="gradient"
        color="dark"
        disabled={!checkAllFields()}
        onClick={handleSubmitDistrict}
        >
        Update
        </MaterialButton>
      </>
      )}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  )
}

export default DistrictForm